import Heading from '@zenbusiness/zui/Heading';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import CheckIcon from '@mui/icons-material/Check';

const ModalTitleSaved = ({ text, saved = false }) => (
  <>
    <Heading
      color="primary"
      size="xl"
    >
      {text}
    </Heading>
    {saved && (
      <Text
        component="span"
        size="xs"
        sx={{ position: 'relative', top: '-3px', left: '10px' }}
      >
        <CheckIcon fontSize="x-small" />
        Saved
      </Text>
    )}
  </>
);

ModalTitleSaved.propTypes = {
  text: PropTypes.string.isRequired,
  saved: PropTypes.bool
};

export default ModalTitleSaved;
